// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__zR5vK","employee-header__buttons":"Header_employee-header__buttons__3Kpl0","employee-header-item":"Header_employee-header-item__RzWWy"};